import { render } from "./DRMirroringVMAdd.vue?vue&type=template&id=b81fcd9a&scoped=true"
import script from "./DRMirroringVMAdd.vue?vue&type=script&lang=js"
export * from "./DRMirroringVMAdd.vue?vue&type=script&lang=js"

import "./DRMirroringVMAdd.vue?vue&type=style&index=0&id=b81fcd9a&scoped=true&lang=scss"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81fcd9a"]])

export default __exports__